import { render, staticRenderFns } from "./OeGenGuide.vue?vue&type=template&id=36e68513&scoped=true&"
import script from "./OeGenGuide.vue?vue&type=script&lang=js&"
export * from "./OeGenGuide.vue?vue&type=script&lang=js&"
import style0 from "./OeGenGuide.vue?vue&type=style&index=0&id=36e68513&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e68513",
  null
  
)

export default component.exports